export enum SidePanelRoute {
  Home = 'sidebar/home',
  Assistant = 'sidebar/assistant',
  Recorder = 'sidebar/recorder',
  Copilot = 'sidebar/copilot',
  Options = 'sidebar/options',
  PopularApps = 'sidebar/popular-apps',
  RecommendedScribes = 'sidebar/recommended-scribes',
  RecommendedScribesOnboarding = 'sidebar/recommended-scribes-onboarding',
  RecommendedScribesSuggestedPreview = 'sidebar/suggested-scribe-preview',
  RecommendedScribesRejectionFeedback = 'sidebar/recommended-scribes-rejection-feedback',
}

export enum CreateFirstActionCondition {
  /** Auto-create the first action if audio recording is active */
  AUDIO_ONLY = 'audio-only',
  ALWAYS = 'always',
  NEVER = 'never',
}
